import React from 'react';
import { colors, spacing, typography, borders } from '../../../../tokens';
import { BRIDGE_NETWORKS } from '../constants';

interface SourceNetworkSelectorProps {
  selectedChainId: number;
  onSelect: (chainId: number) => void;
  disabled?: boolean;
}

/**
 * Component for selecting source network (Polygon or Ethereum)
 */
export const SourceNetworkSelector: React.FC<SourceNetworkSelectorProps> = ({
  selectedChainId,
  onSelect,
  disabled = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.sm,
      }}
    >
      <label
        style={{
          fontSize: typography.fontSize.sm,
          fontWeight: typography.fontWeight.medium,
          color: colors.text.secondary.default,
        }}
      >
        From Network
      </label>
      <div
        style={{
          display: 'flex',
          gap: spacing.md,
        }}
      >
        {BRIDGE_NETWORKS.map((network) => {
          const isSelected = network.chainId === selectedChainId;

          return (
            <button
              key={network.chainId}
              onClick={() => onSelect(network.chainId)}
              disabled={disabled}
              style={{
                flex: 1,
                padding: spacing.md,
                backgroundColor: isSelected
                  ? colors.brand.primary.base
                  : colors.background.secondary.default,
                border: `1px solid ${
                  isSelected ? colors.brand.primary.base : colors.border.default.default
                }`,
                borderRadius: borders.component.card.radius,
                color: isSelected ? colors.text.primary.default : colors.text.secondary.default,
                fontSize: typography.fontSize.base,
                fontWeight: typography.fontWeight.medium,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                transition: 'all 0.2s ease',
              }}
            >
              {network.name}
            </button>
          );
        })}
      </div>
      <div
        style={{
          fontSize: typography.fontSize.xs,
          color: colors.text.muted.default,
          marginTop: spacing.xs,
        }}
      >
        Destination: BSC (fixed)
      </div>
    </div>
  );
};
